import FormField from 'components/FormField';
import { FV } from './share';
import { useTranslate } from '@tolgee/react';
import { Switch } from 'antd';
import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';

function InSiteRemindEnable() {
  const { t } = useTranslate();

  const { whiteListConfig: { AIDE_REMOVE_TASK } = {} } = useOrgConfigStateValue();

  return (
    <FormField<FV['inSiteRemindEnable']>
      required
      name="inSiteRemindEnable"
      label={AIDE_REMOVE_TASK ? t('aide.策略开关') : t('aide.任务开关')}
    >
      {({ field: { value, onChange } }) => {
        return (
          <Switch
            checked={value}
            onChange={onChange}
            checkedChildren={t('aide.开')}
            unCheckedChildren={t('aide.关')}
          />
        );
      }}
    </FormField>
  );
}

export default InSiteRemindEnable;
